
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component({})
  export default class PopUpContainer extends Vue {
    @Prop({ type: Boolean, default: false }) readonly lightBackground!: boolean;

    get backgroundStyle(): Object {
      return {
        "opacity-25 bg-black": !this.lightBackground,
      };
    }
  }
